export enum FeatureFlag {
  CCS = "ccs",
  ColorTheme = "color_theme",
  DefaultLanguage = "default_language",
  DefaultRegion = "default_region",
  FavoriteBar = "favorite_bar",
  Timezone = "time_zone",
  FavoritesInUnifiedSearch = "favorites_unified_search",
  LanguageSelectorInNav = "language_selector_in_nav",
  KrakenInUnifiedSearch = "kraken_in_unified_search",
  NewUnifiedSearchDomainInUnifiedSearch = "new_unifiedsearch_domain_in_unified_search",
  UnifiedSearchAWTInNonPublic = "unified_search_awt_nonpublic",
  VPC = "vpc",
  EnabledRegions = "enabled_regions",
  SearchServices = "search_services",
  LegacyFeedback = "legacy_feedback",
  Aperture = "aperture",
  SettingManagement = "setting_management",
  DisableAllServicesLink = "disable_all_services_link",
  SendAllMetricsToPanorama = "send_all_metrics_to_panorama",
  Paddy = "paddy",
  BrowserFavicon = "browser_favicon",
  PageTitle = "page_title",
  ConsoleNotificationsWidget = "console_notifications_widget",
  ACMASmartAppBanner = "acma_smart_app_banner",
  CSVRAnnouncement = "cs_vr_announcement",
}

export enum FeatureStatus {
  Enabled = "enabled",
  Disabled = "disabled",
}
